/**
 * @licence Copyright © 2019 Mercury Redstone BV, all rights reserved
 */

export const setLocalStorage = (key: string, value:string) => localStorage.setItem(key, JSON.stringify(value));
